import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  titleSectionProp: any = {
    title: 'Especialización = Demanda',
    description: 'La manera más práctica de conectarte con los conocimientos que impulsarán tu carrera.'
  };
  List: any[] = [
    {
      title: 'Quién',
      image: './assets/sofbox-v2/images/home-6/602.svg',
      arrow_image: './assets/sofbox-v2/images/home-6/603.png',
      hoverClass: 'purple-hover',
      price: './assets/sofbox-v2/images/home-6/6021.png',
      description: 'Partimos de tu perfil profesional actual para comprender tus fortalezas en función de la industria que te interesa.',
      services: [ 
        { title: 'Análisis de experiencia y habilidades actuales', icon: 'ion ion-checkmark-round' },
        { title: 'Mapeo de industrias compatibles', icon: 'ion ion-checkmark-round' },
        { title: 'Perfilamiento según tendencias del mercado', icon: 'ion ion-checkmark-round' },
      ]
    },
    { 
      title: 'Qué',
      image: './assets/sofbox-v2/images/home-6/603.svg',
      arrow_image: './assets/sofbox-v2/images/home-6/605.png',
      class: 'flex-row-reverse',
      hoverClass: 'purple-hover',
      price: './assets/sofbox-v2/images/home-6/6031.png',
      description: 'Detectamos la formación que necesitas según la industria y especialización del puesto al que querés acceder.',
      services: [ 
        { title: 'Identificación de brechas de conocimiento', icon: 'ion ion-checkmark-round' },
        { title: 'Ruta de aprendizaje personalizada por etapas', icon: 'ion ion-checkmark-round' },
        { title: 'Compatibilidad con demandas de la industria', icon: 'ion ion-checkmark-round' },
      ]
    },
    { 
      title: 'Cómo',
      image: './assets/sofbox-v2/images/home-6/604.svg',
      hoverClass: 'purple-hover',
      price: './assets/sofbox-v2/images/home-6/6041.png',
      description: 'Te conectamos con las instituciones educativas de primer nivel a tu alcance con propuestas personalizadas para que elijas la opción que mejor se adapte a vos.',
      services: [ 
        { title: 'Espectativas de contenido', icon: 'ion ion-checkmark-round' },
        { title: 'Ritmo de estudio', icon: 'ion ion-checkmark-round' },
        { title: 'Precio', icon: 'ion ion-checkmark-round' },
        { title: 'Opciones presenciales, híbridas o 100% online ', icon: 'ion ion-checkmark-round' }
      ]
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}


